import { render, staticRenderFns } from "./baogaolist.vue?vue&type=template&id=a765d11e&scoped=true"
import script from "./baogaolist.vue?vue&type=script&lang=js"
export * from "./baogaolist.vue?vue&type=script&lang=js"
import style0 from "./baogaolist.vue?vue&type=style&index=0&id=a765d11e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a765d11e",
  null
  
)

export default component.exports